import { IReport6ReportingPeriod } from "./Report6ReportingPeriod";
import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TReport6Applicant {
  id: number;
  partyId: number;
  name: string;
  lastName: string;
}

export interface IReport6Applicant extends TReport6Applicant {
  fullName: string;
  reportingPeriods: IReport6ReportingPeriod[];
}

const Report6Applicant = Model(
  (model: TReport6Applicant): IReport6Applicant => {
    const _report6Applicant: TReport6Applicant = Object.assign({}, model);

    let create = (report6Applicant: IReport6Applicant): IReport6Applicant => {
      let obj = ValidatableObject(report6Applicant);
      return obj;
    };

    let _reportingPeriods: IReport6ReportingPeriod[] = [];

    let report6Applicant = {
      get id() {
        return _report6Applicant.id;
      },
      set id(value) {
        _report6Applicant.id = value;
      },
      get partyId() {
        return _report6Applicant.partyId;
      },
      set partyId(value) {
        _report6Applicant.partyId = value;
      },
      get name() {
        return _report6Applicant.name;
      },
      set name(value) {
        _report6Applicant.name = value;
      },
      get lastName() {
        return _report6Applicant.lastName;
      },
      set lastName(value) {
        _report6Applicant.lastName = value;
      },
      get fullName() {
        return `${this.name} ${this.lastName}`;
      },
      get reportingPeriods() {
        return _reportingPeriods;
      },
      set reportingPeriods(value) {
        _reportingPeriods = value;
      }
    };
    return create(report6Applicant);
  }
);

export default Report6Applicant;
